import { render, staticRenderFns } from "./AlbumMenu.vue?vue&type=template&id=dd7d5c32&"
import script from "./AlbumMenu.vue?vue&type=script&lang=js&"
export * from "./AlbumMenu.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports